export default "__VITE_ASSET__BNmyy0Cb__"